export default __webpack_public_path__ + "static/media/wwa-branco.5aeb6100.png";